<template>
  <!-- 概况 -->
  <client-module class="overview" :moduletitle="title">
    <div class="module-box">
      <div class="overview-item" v-for="item in dataList" :key="item.id">
        <el-card class="data-box">
          <div class="title">{{ item.title }}</div>
          <div class="number">
            <span>{{ item.value }}</span>
            <span>{{item.valueUnit}}</span>
            <!-- <span v-if="item.id == 1 && item.value != '-'">个</span>
            <span v-if="item.id == 2 && item.value != '-'">/个</span> -->
          </div>
          <div class="bottom">
            <div class="period" v-if="showperiod">
              {{ hint }}{{ item.period }}
              <span>{{item.periodUnit}}</span>
              <!-- <span v-if="item.id == 1 && item.period != '-'">个</span>
              <span v-if="item.id == 2 && item.period != '-'">/个</span> -->
            </div>

            <div class="efficiency">
              <ig-icon
                v-if="item.iconData == 'shangsheng'"
                :name="item.iconData"
                style="color:#F5222D; "
              ></ig-icon>
              <ig-icon
                v-if="item.iconData == 'xiajiang'"
                :name="item.iconData"
                style="color: #52C41A;"
              ></ig-icon>
              <span class="efficiency-data"
                >{{ item.message }}{{ item.efficiency }}</span
              >
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </client-module>
</template>

<script>
import clientModule from "@/components/client/clientModule/clientModule.vue";
export default {
  props: {
    title: {
      type: String
    },
    dataList: {
      type: Array
    },
    showperiod: {
      type: Boolean,
      default: true
    },
    hint: {
      type: String,
      default: "上一周期："
    }
  },
  data() {
    return {};
  },
  methods: {},
  components: { clientModule }
};
</script>

<style lang="scss" scoped>
.overview {
  background-color: #fff;
  margin-top: 10px;
  text-align: center;
  .module-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .overview-item {
      height: 100%;
      padding: 0 10px;
      flex: 1;
      .data-box {
        height: 100%;
        background-color: #fff;
        .number {
          width: 100%;
          height: 100px;
          line-height: 100px;
          span:nth-child(1) {
            font-size: 36px;
          }
        }
        .bottom {
          height: 50px;
          line-height: 50px;
          border-top: 1px solid #ccc;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .period {
            border-right: 1px solid #ccc;
          }
          .efficiency .efficiency-data {
            margin-left: 10px;
          }
          .period,
          .efficiency {
            flex: 1;
          }
        }
      }
    }
    .item-padding {
      padding: 0 10px;
    }
  }
}
</style>
